import styled from '@emotion/styled';

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: #d9d9d9;
  margin: 1.5em 0em;
`;

export default Separator;